"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSharedService = void 0;
const context_1 = require("./context");
const react_1 = require("react");
function useSharedService(service) {
    const context = (0, context_1.useSharedValueStoreContext)();
    return (0, react_1.useMemo)(() => context.service(service), [context]);
}
exports.useSharedService = useSharedService;
//# sourceMappingURL=use-shared-service.js.map